import React, { useEffect, useState } from 'react';
import { IOffer } from '../../../../../../../model/offer/IOffer';
import HistoryDetail from '../../../../../../brand/campaign/book/offer/modal/tabs/history/HistoryDetail';
import { ManagementOfferService } from '../../../../service';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../../../store/rootReducer';
import { ErrorToast } from '../../../../../../../utils/toasters';

export function HistoryTab() {
    const { campaignId, isCharity } = useSelector((state: IAllStates) => state.offerInfluencer);
    const [historyOffers, setHistoryOffers] = useState<IOffer[]>([]);

    useEffect(() => {
        ManagementOfferService.getOfferHistory(campaignId)
            .then(response => {
                setHistoryOffers(response);
            })
            .catch(err => ErrorToast(err));
    }, []);

    return (
        <>
            {historyOffers.map(offer => (
                <HistoryDetail key={offer?.id} offer={offer} isCharity={isCharity} />
            ))}
        </>
    );
}
